module.exports = __webpack_public_path__ + "img/567x600px-Aram.7bb77410.jpeg";